import { PipelineAbandonedBasketConfig } from "../validations"
import { z } from "zod"

export default function isUserTestGroupsNotOverlapping(
  pipelineAbandonedBasketConfigs: z.infer<typeof PipelineAbandonedBasketConfig>[]
): boolean {
  const result: number[] = []

  for (let configItem of pipelineAbandonedBasketConfigs) {
    for (let userTestGroup of configItem.userTestGroups) {
      if (result.includes(userTestGroup)) {
        return false
      }

      result.push(userTestGroup)
    }
  }

  return true
}
